export default __webpack_public_path__ + "static/media/EstatutoLV.448874d3.pdf";